import React, { useEffect, useState } from "react";
import { FaWindows } from "react-icons/fa";
import { IoLogoApple } from "react-icons/io5";
import { LuExternalLink } from "react-icons/lu";
import { TfiDownload } from "react-icons/tfi";
import {
  FlexBoxHorizontal,
  FlexBoxVertical,
  Typography,
  TranslateTypography,
} from "../../atoms";
import palette from "../../../utils/colorPalette";
import { LanguageButton } from "../../molecules";
import MilkyWayMenu from "./MilkyWayMenu";

const MilkyWayDownloadHQ = () => {
  const [updateUrl, setUpdateUrl] = useState({});
  const [requestOpen, setRequestOpen] = useState(false);
  
  

  useEffect(() => {
    fetch("/api/get-update-url")
      .then((res) => res.json())
      .then((res) => {
        console.log("F&F URLs:", res);
        setUpdateUrl(res);
      })
      .catch((err) => {
        console.error("Error fetching update url:", err);
      });
  }, []);

  return (
    <>
      <MilkyWayMenu currentCompany="fnf" />

      <FlexBoxVertical
        style={{
          margin: "0 auto",
          width: "1150px",
          alignItems: "baseline",
          padding: "80px 20px",
          height: "auto",
        }}
      >
        {/* 언어 버튼 */}
        <div style={{ alignSelf: "flex-end", marginBottom: "10px" }}>
          <LanguageButton />
        </div>

        {/* 헤더 */}
        <Typography
          variant="header1"
          style={{
            fontWeight: "bold",
            borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
            paddingBottom: "30px",
            width: "100%",
          }}
        >
          F&F Dashboard
        </Typography>

        <TranslateTypography
          style={{
            marginTop: "30px",
            marginBottom: "10px",
            fontSize: "19px",
            fontWeight: "bold",
          }}
        >
          보다 강력한 기능을 포함하고 있는 새로운 대시보드 MilkyWay
        </TranslateTypography>
        <TranslateTypography style={{ fontSize: "14px", marginBottom: "10px" }}>
          사용 중인 PC에 맞는 설치 파일을 다운로드해 주세요.
        </TranslateTypography>

        {/* 다운로드 카드 */}
        <FlexBoxHorizontal
          style={{
            height: "40%",
            borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
            paddingBottom: "50px",
          }}
        >
          <DownloadCard
            platform="Windows"
            icon={<FaWindows style={{ marginBottom: "-1%" }} />}
            links={[{ label: "Windows 설치 파일", url: updateUrl.windows }]}
          />
          <DownloadCard
            platform="Mac"
            icon={<IoLogoApple style={{ marginBottom: "-1%" }} />}
            links={[
              { label: "Intel 설치 파일", url: updateUrl.intel },
              { label: "M1, M2 설치 파일", url: updateUrl.m1m2 },
            ]}
          />
        </FlexBoxHorizontal>

        {/* 링크 */}
        <p style={{ fontSize: "14px", marginBottom: "-5px" }}>
          <a
            href="#"
            onClick={(e) => { e.preventDefault(); setRequestOpen(true); }}
            style={{ color: palette.button.primary }}
          >
            <LuExternalLink />{" "}
            <TranslateTypography variant="content1">
              밀키웨이 권한 신청
            </TranslateTypography>
          </a>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <a
            href="https://www.notion.so/fnf-digital/Milkyway-User-Guide-6a3f660c371449c5a5e757678e807b96?pvs=4"
            style={{ color: palette.buttonText.change }}
            target="_blank"
            rel="noopener noreferrer"
          >
            <LuExternalLink />{" "}
            <TranslateTypography variant="content1">
              밀키웨이 설치 가이드
            </TranslateTypography>
          </a>
        </p>

        <TranslateTypography
          style={{ margin: "20px 0 10px 0", fontSize: "14px" }}
        >
          Explorer 와 Safari는 지원하지 않습니다.
        </TranslateTypography>
        <TranslateTypography style={{ margin: "0", fontSize: "14px" }}>
          오류 신고나 신규 개발 요청, 권한 요청은 AI 엔지니어링팀 BI파트로 연락
          부탁드립니다.
        </TranslateTypography>
      </FlexBoxVertical>
      
      {/* 권한 신청 모달 */}
      {requestOpen && (
        <div
          onClick={() => setRequestOpen(false)}
          style={{
            position: "fixed", inset: 0, zIndex: 1000,
            background: "rgba(0,0,0,0.45)",
            display: "flex", alignItems: "center", justifyContent: "center",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "780px", maxWidth: "95vw",
              background: "#fff", borderRadius: "14px",
              boxShadow: "0 8px 40px rgba(0,0,0,0.18)",
              overflow: "hidden", display: "flex", flexDirection: "column",
              maxHeight: "90vh",
            }}
          >
            {/* 모달 헤더 */}
            <div style={{
              padding: "16px 20px", background: "#353339",
              display: "flex", alignItems: "center", justifyContent: "space-between",
              flexShrink: 0,
            }}>
              <span style={{ color: "#fff", fontWeight: 600, fontSize: "15px" }}>
                MILKYWAY 권한 신청
              </span>
              <button
                onClick={() => setRequestOpen(false)}
                style={{ background: "none", border: "none", color: "rgba(255,255,255,0.7)", fontSize: "20px", cursor: "pointer", lineHeight: 1, padding: "0 2px" }}
              >✕</button>
            </div>

            {/* 공지 */}
            <div style={{
              padding: "14px 20px", background: "#f9f8f6",
              borderBottom: "1px solid #e5e0d8", fontSize: "13px",
              color: "#4a4540", lineHeight: "1.75", flexShrink: 0,
            }}>
              <div style={{ fontWeight: 600, marginBottom: "6px", color: "#2d2926" }}>권한 신청 안내</div>
              <p style={{ margin: "0 0 4px 0" }}>
                포맷에 맞게 작성하여 신청해주시면, <strong>프로세스 부문 박봉섭 이사님</strong> 컨펌 후 권한 부여하고 알람드리겠습니다.
              </p>
              <p style={{ margin: "0 0 4px 0" }}>
                <strong>매일 오후 2시</strong>에 순차적으로 권한 신청을 확인하고 설정해 드리고 있습니다. 오후 2시 이후 접수 건은 다음 날 처리됩니다.
              </p>
              <p style={{ margin: 0, color: "#7a7068" }}>
                급하게 권한이 필요한 경우 <strong>AI 엔지니어링팀 엄지민 담당</strong>에게 문의 부탁드립니다.
              </p>
            </div>

            {/* Tally 폼 */}
            <div style={{ flex: 1, minHeight: "500px", position: "relative" }}>
              <iframe
                src="https://tally.so/embed/zxZWr1?hideTitle=1"
                width="100%" height="100%"
                frameBorder="0" title="밀키웨이 권한 신청"
                style={{ position: "absolute", inset: 0, border: 0 }}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

function DownloadCard({ platform, icon, links }) {
  return (
    <div
      style={{
        width: "280px",
        height: "260px",
        backgroundColor: "#353339",
        margin: "50px",
        borderRadius: "5px",
        padding: "20px",
        color: "white",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div style={{ fontSize: "30px", margin: "6px 10px" }}>
        {icon}&nbsp;{platform}
      </div>
      {links.map((link, index) => (
        <a
          key={index}
          href={link.url}
          download
          style={{
            display: "inline-block",
            backgroundColor: link.url ? "white" : "#888",
            border: "0px solid #202a44",
            width: "80%",
            height: "50px",
            fontSize: "15px",
            borderRadius: "30px",
            textAlign: "center",
            lineHeight: "50px",
            color: "#353339",
            textDecoration: "none",
            margin: "15px 20px",
            pointerEvents: link.url ? "auto" : "none",
            opacity: link.url ? 1 : 0.6,
          }}
          onMouseOver={(e) =>
            link.url && (e.target.style.boxShadow = "0 0 5px white")
          }
          onMouseOut={(e) => (e.target.style.boxShadow = "none")}
        >
          <TfiDownload style={{ marginRight: "8px", fontSize: "12px" }} />
          <TranslateTypography>
            {link.url ? link.label : "로딩중..."}
          </TranslateTypography>
        </a>
      ))}
    </div>
  );
}

export default MilkyWayDownloadHQ;
